<p-table #dt [value]="activities" class="mt-1" showGridlines *ngIf="activities && activities.length > 0"
  [sortField]="sortField" [sortOrder]="sortOrder" [paginator]="showPaginator" [rows]="pageSize"
  paginatorPosition="bottom" [lazy]="false" filterBy="ActivityId,ActivityName,PrimaryResource,Crew1,Crew2,CoRep,Comment"
  [globalFilterFields]="['ActivityId', 'ActivityName', 'PrimaryResource','Crew1','Crew2','CoRep','Comment']">

  <ng-template #header>
    <tr class="table-primary text-center">
      <th scope="col">
        <div [ngClass]="{'sorted': sortField == 'ActivityId', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('ActivityId')" class="text-dark">{{'COMPONENTS.ActivityId' | translate}}</a>
        </div>
      </th>
      <th scope="col">
        <div [ngClass]="{'sorted': sortField == 'ActivityName', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('ActivityName')" class="text-dark">{{'COMPONENTS.ActivityName' | translate}}</a>
        </div>
      </th>
      <th scope="col">
        <div [ngClass]="{'sorted': sortField == 'WorkPriority', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('WorkPriority')" class="text-dark">{{'COMPONENTS.WorkPriority' | translate}}</a>
        </div>
      </th>
      <th scope="col">
        <div [ngClass]="{'sorted': sortField == 'PrimaryResource', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('PrimaryResource')" class="text-dark">{{'COMPONENTS.PrimaryResource' |
            translate}}</a>
        </div>
      </th>
      <th scope="col">
        <div
          [ngClass]="{'sorted': sortField == 'PrimaveraPercentComplete', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('PrimaveraPercentComplete')" class="text-dark">{{'COMPONENTS.Primavera' | translate}}
            %</a>
        </div>
      </th>
      <th scope="col">
        <div
          [ngClass]="{'sorted': sortField == 'InternalPercentComplete', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('InternalPercentComplete')" class="text-dark">{{'COMPONENTS.MobileUpdated' |
            translate}} %</a>
        </div>
      </th>
      <th scope="col">
        <div
          [ngClass]="{'sorted': sortField == 'ActualDatesChanged', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('ActualDatesChanged')" class="text-dark">{{'COMPONENTS.ActualDatesUpdated' |
            translate}}</a>
        </div>
      </th>
      <th scope="col">
        <div [ngClass]="{'sorted': sortField == 'ActualStartDate', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('ActualStartDate')" class="text-dark">{{'COMPONENTS.ActualDates' | translate}}</a>
        </div>
      </th>
      <th scope="col">
        <div
          [ngClass]="{'sorted': sortField == 'ActualFinishDate', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('InternalActualStartDate')" class="text-dark">{{'COMPONENTS.UpdatedActualDates' |
            translate}}</a>
        </div>
      </th>
      <th scope="col">
        <div [ngClass]="{'sorted': sortField == 'Crew1', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('Crew1')" class="text-dark">{{'COMPONENTS.PrimaryCrew' | translate}}</a>
        </div>
      </th>
      <th scope="col">
        <div [ngClass]="{'sorted': sortField == 'CoRep', 'asc' : sortOrder === 1, 'desc' : sortOrder === -1}">
          <a (click)="onSortChange('CoRep')" class="text-dark">{{'COMPONENTS.CompanyReps' | translate}}</a>
        </div>
      </th>
      <th scope="col" *ngIf="projectQtyEnable && InstanceQtyEnable === 'true'">
        <div >
          <a class="text-dark">Planned Quantity</a>
        </div>
      </th>
      <th scope="col" *ngIf="projectQtyEnable && InstanceQtyEnable === 'true'">
        <div>
          <a class="text-dark">Actual Quantity</a>
        </div>
      </th>
      <th scope="col">
        <div><a class="text-dark">{{'COMPONENTS.Comment' | translate}}</a></div>
      </th>
      <th scope="col">
        <div><a class="text-dark">{{'COMPONENTS.History' | translate}}</a></div>
      </th>
    </tr>
  </ng-template>

  <ng-template #body let-a>
    <tr class="text-center" [ngClass]="{'bg-warning' : a.IsFutureShift === true || a.IsOutOfSequence === true}">
      <td>
        <span class="text-danger" title="Future shift" *ngIf="a.IsFutureShift === true">
          <i class="pi pi-exclamation-circle"></i>
        </span>
        <span class="text-danger" title="Out of Sequence" *ngIf="a.IsOutOfSequence === true">
          <i class="pi pi-exclamation-circle"></i>
        </span>
        <p-checkbox [(ngModel)]="a.isApproved" [binary]="true" *ngIf="showrejectpanel"
          class="form-check-input"></p-checkbox><br>
        <span>{{a.ActivityId}}</span>
      </td>
      <td>{{a.ActivityName}}</td>
      <td>{{a.WorkPriority}}</td>
      <td>{{a.PrimaryResource}}</td>
      <td>{{a.PrimaveraPercentComplete}}</td>
      <td>{{a.InternalPercentComplete}}</td>
      <td>{{a.ActualsManuallyUpdated ? 'Yes' : 'No'}}</td>
      <td>
        {{a.ActualStartDate | momentPipe: 'L HH:mm': true}} -
        {{a.ActualFinishDate | momentPipe: 'L HH:mm': true}}
      </td>
      <td>
        {{a.InternalActualStartDate | momentPipe: 'L HH:mm': true}} -
        {{a.InternalActualFinishDate | momentPipe: 'L HH:mm': true}}
      </td>
      <td>{{a.Crew1}}</td>
      <td>{{a.CoRep}}</td>
      <ng-container *ngIf="projectQtyEnable && InstanceQtyEnable === 'true'">
      <td>{{a.PlannedQuantity}}</td>
      <td>{{a.ActualQuantity}}</td>
      </ng-container>
      <td>
        <a *ngIf="a.HasJustifications" style="color: blue;"
          (click)="onClickShowJustifications(a)">{{'COMPONENTS.Details' | translate}}</a>
      </td>
      <td>
        <a (click)="this.onAuditLogClick(a)" style="color: blue;">{{'COMPONENTS.History' | translate}}</a>
      </td>
    </tr>
    <tr>
      <td colspan="15">
        <div class="card mb-3" *ngIf="showrejectpanel && a.isApproved === false">
          <div class="card-body">
            <h5 class="card-title">Please specify rejection comment</h5>
            <textarea pInputTextarea rows="3" class="form-control" [(ngModel)]="a.rejectionComment"></textarea>
            <div class="card-footer text-end">
              <button class="btn btn-secondary" (click)="cancelRejection(a)">{{'COMPONENTS.Cancel' |
                translate}}</button>
              <button class="btn btn-danger" (click)="raiseRejection(a)"
                [disabled]="!a.rejectionComment || a.rejectionComment.length===0">
                {{'COMPONENTS.Reject' | translate}}
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="a.DisplayJustifications">
          <app-activity-justifications [activityId]="a.Id"></app-activity-justifications>
          <hr class="my-0">
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>


<div *ngIf="!activities || activities.length ===0">
  <h5>{{'COMPONENTS.NoData' | translate}}</h5>
</div>